import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDadosBancariosPDVComponent } from 'src/app/shared/modals/modal-dados-bancarios-pdv/modal-dados-bancarios-pdv.component';
import { TokenService } from 'src/app/shared/services/token.service';
import { UsuarioService } from 'src/app/shared/services/usuario.service';
import Swal from 'sweetalert2';
import { BeneficioService } from '../../../services/previdencia/beneficio.service';
import { PeculioService } from '../../../services/previdencia/peculio.service';
import { SolicitationService } from '../../../services/usuario/solicitation.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-solicitar-peculio',
  templateUrl: './solicitar-peculio.component.html',
  styleUrls: ['./solicitar-peculio.component.css']
})
export class SolicitarPeculioComponent implements OnInit {

  prazoLimiteExcedido: boolean = true;
  dados: any;
  user: any;
  meuPlano: any;
  solicitacoes: any[] = [];
  formulario!: FormGroup;
  somaTotal: any;
  listaDependentesTitular!: any;
  listaDocumentos: any[] = [];
  loading = 0;
  loadingSave: boolean = false;
  listaParentes = [{ value: 'MÃE' }, { value: 'COMPANHEIRO(A)' }, { value: 'FILHO(A)' }, { value: 'OUTROS (DESIGNADOS)' }, { value: 'MADASTRA' }, { value: 'TUTELADO' }, { value: 'IRMÃO(A)' }, { value: 'MENOR SOB GUARDA' }, { value: 'PADASTRO' }, { value: 'REPRESENTANTE LEGAL' }, { value: 'EX-COMPANHEIRO(A)' }, { value: 'TITULAR - PECÚLIO' }, { value: 'NETO(A)' }, { value: 'MENOR POBRE' }, { value: 'PAI' }, { value: 'CÔNJUGE' }, { value: 'EX-CÔNJUGE' }, { value: 'ENTEADO(A)' }, { value: 'DETERMINAÇÃO JUDICIAL' }];
  faSquareXmark = faSquareXmark;
  formChanged: boolean = false;
  opcaoEscolhida: boolean = false;
  peculio: any = null;
  formTitulo: FormGroup = this._formBuilder.group({
    opcao: new FormControl(0),
    valorPeculio: new FormControl(null),
    novaContribuicao: new FormControl(null),
    valorContribuicao: new FormControl(null),
    novoPeculio: new FormControl(null),
    valorReferencial: new FormControl(null),
  });
  formPessoa: FormGroup = this._formBuilder.group({
    name: new FormControl(null),
    matricula: new FormControl(null),
    cpf: new FormControl(null)
  });
  formContact: FormGroup = new FormGroup({
    cep: new FormControl(null, [Validators.required]),
    address: new FormControl(null, [Validators.required]),
    number: new FormControl(null, [Validators.required]),
    complement: new FormControl(null),
    district: new FormControl(null, [Validators.required]),
    postalCode: new FormControl(null),
    city: new FormControl(null, [Validators.required]),
    state: new FormControl(null, [Validators.required]),
    country: new FormControl(null, [Validators.required]),
    personalPhone: new FormControl(null, [Validators.required]),
    comercialPhone: new FormControl(null),
    email: new FormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')]),
    secondaryEmail: new FormControl(null, [Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')]),
    replicateDependant: new FormControl(false),
    registration: new FormControl(null),
  });
  constructor(private router: Router, private _formBuilder: FormBuilder, private solicitationService: SolicitationService, private peculioService: PeculioService,
    private modalService: NgbModal, private beneficioService: BeneficioService, private userService: UsuarioService, private tokenService: TokenService) {
    this.formulario = this._formBuilder.group({
      listaDependentes: this._formBuilder.array([]),
    });
  }

  // função para ver se estamos e maio
  VisualizarMes(){
    const dataAtual = new Date();
    const mesAtual = dataAtual.getMonth() + 1;
    const anoAtual = dataAtual.getFullYear();
    const diaAtual = dataAtual.getDate();

    if (mesAtual >= 5 && anoAtual == 2025) {
      if (diaAtual > 5) {
        this.prazoLimiteExcedido = false;
      } else {
        this.prazoLimiteExcedido = true;
      }
    } else{
      this.prazoLimiteExcedido = true;
    }
  }

  cepChanged() {
    if (this.formContact.get('cep')?.value.length == 8) {
      this.solicitationService.getZipCodeParams(this.formContact.get('cep')?.value)
        .subscribe((res: any) => {
          if (res.localidade) {
            if (res.logradouro) {
              this.formContact.get('address')?.setValue(res.logradouro.toUpperCase());
              this.formContact.get('address')?.disable();
            } else {
              this.formContact.get('address')?.setValue(null);
              this.formContact.get('address')?.enable();
            }
            this.formContact.get('city')?.setValue(res.localidade.toUpperCase());
            this.formContact.get('city')?.disable();
            this.formContact.get('state')?.setValue(res.uf.toUpperCase());
            this.formContact.get('state')?.disable();
            if (res.bairro) {
              this.formContact.get('district')?.setValue(res.bairro.toUpperCase());
              this.formContact.get('district')?.disable();
            } else {
              this.formContact.get('district')?.setValue(null);
              this.formContact.get('district')?.enable();
            }
            this.formContact.get('country')?.setValue('BRASIL');
            this.formContact.get('country')?.disable();
            this.formContact.updateValueAndValidity();
          } else {
            this.formContact.get('cep')?.setErrors({ 'incorrect': true });
            this.formContact.get('address')?.setValue(null);
            this.formContact.get('address')?.enable();
            this.formContact.get('city')?.setValue(null);
            this.formContact.get('state')?.setValue(null);
            this.formContact.get('district')?.setValue(null);
            this.formContact.get('district')?.enable();
            this.formContact.get('country')?.setValue('BRASIL');
          }
        });
    } else {
      this.formContact.get('address')?.setValue(null);
      this.formContact.get('address')?.enable();
      this.formContact.get('address')?.updateValueAndValidity();
      this.formContact.get('city')?.setValue(null);
      this.formContact.get('city')?.enable();
      this.formContact.get('city')?.updateValueAndValidity();
      this.formContact.get('state')?.setValue(null);
      this.formContact.get('state')?.enable();
      this.formContact.get('state')?.updateValueAndValidity();
      this.formContact.get('district')?.setValue(null);
      this.formContact.get('district')?.enable();
      this.formContact.get('district')?.updateValueAndValidity();
      this.formContact.get('country')?.setValue('BRASIL');
      this.formContact.get('country')?.enable();
      this.formContact.get('country')?.updateValueAndValidity();
    }
    this.formContact.markAllAsTouched();
  }
  finalizarSolicitacao() {
    let request = {
      opcao: this.formTitulo.get('opcao')?.value as number,
      files: this.listaDocumentos,
      contato: this.formContact.value,
      contatoAlterado: this.formChanged,
      meuPlano: this.meuPlano
    };
    this.loadingSave = true;
    Swal.fire({
      title: 'Deseja finalizar essa solicitação?',
      html: `<section style="margin: 0.5rem; color: #d25401 !important; font-weight: 500;font-size: 0.875rem;">
              <p>* Lembre-se de que a escolha é irretratável. Portanto, finalize somente se tiver certeza da opção escolhida.</p>
            </section>`,
      icon: 'warning',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "Sim, Finalizar!",
      cancelButtonText: "Não, Voltar!",
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.peculioService.postSavePeculio(JSON.stringify(request)).subscribe({
          next: (res: any) => {
            Swal.fire({
              title: '',
              html: request.opcao == 3
                ? ` <section style="text-align: justify !important;">
                      <p style=" text-align: center; font-size: 0.875rem;">
                        <b>Parabéns!</b> Você concluiu o processo de escolha de uma das opções do Plano Pecúlio! 
                      </p>
                      </br>
                      <h6 style="margin-bottom:0.25rem;">Cronograma de Pagamentos:</h6>              
                      <ol style="font-size: 0.75rem; list-style: disc; margin-left: 1.25rem;" *ngIf="opcao == 3">
                        <li>Solicitações até o dia 31/01/2025, a previsão de recebimento é dia 17/02/2025;</li>
                        <li>Solicitações até o dia 28/02/2025, a previsão de recebimento é dia 17/03/2025;</li>
                        <li>Solicitações até o dia 31/03/2025, a previsão de recebimento é dia 15/04/2025;</li>
                        <li>Solicitações até o dia 16/04/2025, a previsão de recebimento é dia 15/05/2025;</li>
                      </ol>
                      <p style="font-size: 0.75rem;">
                        O Plano Família é uma excelente opção para aplicar esse valor, para entrar em contato <a style="color: #F46201; font-weight: 500;text-decoration: underline;" target="_blank" href="https://wa.me/5541991090964">clique aqui</a>.!
                      </p>
                    </section>`
                : ` <section style="text-align: justify !important;">
                      <p style=" text-align: center; font-size: 0.875rem;">
                        <b>Parabéns!</b> Você concluiu o processo de escolha de uma das opções do Plano Pecúlio! 
                      </p>
                      </br>
                      <p style="font-size: 0.75rem;">
                        Após esse período de escolha, poderão ser realizadas alterações no valor do pecúlio, mediante comunicação à Fundação Copel.
                      </p>
                      <p style="font-size: 0.75rem;">
                        Caso queira atualizar/alterar os beneficiários do Plano Pecúlio, envie a solicitação para o e-mail <a style="color: #F46201; font-weight: 500;text-decoration: underline;" target="_blank" href="mailto:previdencia@fcopel.org.br">previdencia@fcopel.org.br</a>.
                      </p>
                    </section>`,
              icon: 'success',
              showConfirmButton: false,
              showCancelButton: true,
              cancelButtonText: "Fechar",
            }).then((result: any) => {
              location.reload();
            });
          }
        });
      } else {
        location.reload();
      }
    });
  }
  alterarDadosBancarios() {
    const modalRef = this.modalService.open(ModalDadosBancariosPDVComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.lista = this.listaDocumentos;
    modalRef.result.then((result: any) => {
      if (result) {
        this.listaDocumentos = result;
      }
    }).catch((error: any) => {
    });
  }
  removeDadosBancarios(index: any) {
    this.listaDocumentos.splice(index, 1);
  }
  removeFile(index: number, prop: any) {
    const form = this.listaDependentes.at(prop) as FormGroup;
    const filesArray = form.get('file') as FormArray;
    filesArray.removeAt(index);
  }
  createDocument(enabled: boolean, nome?: string) {
    return this._formBuilder.group({
      name: new FormControl(nome),
      file: new FormControl(null),
      fileName: new FormControl(null),
      MD5: new FormControl(null),
    })
  }
  get listaDependentes(): FormArray {
    return this.formulario.get('listaDependentes') as FormArray;
  }
  excluirDependente(index: number) {
    Swal.fire({
      title: 'Deseja realmente excluir esse dependente?',
      text: '',
      icon: 'question',
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "Continuar",
    }).then((result: any) => {
      if (result) {
        const listaDependentes = this.formulario.get('listaDependentes') as FormArray;
        listaDependentes.removeAt(index);
      }
    });
  }
  getDependenteFormGroup(dependenteData: any): FormGroup {
    const dependente = this._formBuilder.group({
      nome: new FormControl(null),
      vinculo: new FormControl(null),
      percentual: new FormControl(null),
      nomeMae: new FormControl(null),
      nascimento: new FormControl(null),
      cpfAtual: new FormControl({ value: null, disabled: true }),
      cpfAlterar: new FormControl(null),
      telefone: new FormControl(''),
      file: new FormArray([]),
      celular: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')]),
      emailAlternativo: new FormControl(null, [Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$')]),
      endereco: new FormControl(null, [Validators.required]),
      cep: new FormControl(null, [Validators.required]),
      pais: new FormControl(null, [Validators.required]),
      cidade: new FormControl(null, [Validators.required]),
      complemento: new FormControl(null),
      bairro: new FormControl(null, [Validators.required]),
      numero: new FormControl(null, [Validators.required]),
      caixaPostal: new FormControl(null),
      uf: new FormControl(null, [Validators.required]),
      replicarEndereco: new FormControl(false),
    });
    return dependente;
  }
  replicarEndereco() {
  }
  recalcularPorcentagem() {
  }
  callbackDinamico(index: number): void {
  }
  viewDetails(prop: any) {
  }
  adicionarArquivos(documentName: string, event: any, id: any): void {
    const file = this.createDocument(false, documentName);
    file.patchValue(event[0]);
    const form = this.listaDependentes.at(id) as FormGroup;
    const filesArray = form.get('file') as FormArray;
    filesArray.push(file)
  }
  calcularSoma() {
    this.somaTotal = 0;
    this.listaDependentes.controls.forEach((a: any) => {
      const percentual = a.get('percentual')?.value;
      if (percentual) {
        this.somaTotal += percentual;
      }
    });
  }
  ngOnInit(): void {
    this.loading = 0;
    this.user = this.tokenService.getActiveUser();
    this.userService.getUser(this.user.cpf).subscribe((res: any) => {
      this.formContact.patchValue(res.contactResponse);
      this.formContact.markAllAsTouched();
      this.loading++;
    }
    );
    this.peculioService.getPeculioSolicitation().subscribe((res: any) => {
      this.solicitacoes = res;
      console.log('solicitações', this.solicitacoes)

      this.loading++;
    }
    )
    this.beneficioService.getBase().subscribe((res: any) => {
      this.dados = res;
      this.loading++;
    }
    )
    this.peculioService.getValuesPeculio().subscribe((res: any) => {
      if (res == null) {
        this.router.navigate(["home"]);
      }
      this.meuPlano = res;

      console.log('meu plano', this.meuPlano)
      this.formPessoa.get('name')?.setValue(res.nome);
      this.formPessoa.get('matricula')?.setValue(res.matricula);
      this.formPessoa.get('cpf')?.setValue(res.cpf);
      this.formPessoa.markAllAsTouched();
      this.loading++;
    }
    );
    this.peculioService.getPeculio().subscribe((res: any) => {
      if (res == null) {
        this.router.navigate(["home"]);
      }
      this.loading++;
      this.peculio = res.sort((actual: any, last: any) => {
        this.listaDependentesTitular = last.beneficiarios;
        if (actual.tipoSegurado === "TITULAR" && last.tipoSegurado !== "TITULAR") {
          return -1;
        }
        if (actual.tipoSegurado !== "TITULAR" && last.tipoSegurado === "TITULAR") {
          return 1;
        }
        return 0;
      });
      this.calcularSoma();
    });
    this.peculioService.getDependentesPeculio().subscribe((res: any) => {
      this.loading++;
      res.map((element: any) => {
        const dependente = this.getDependenteFormGroup(element);
        dependente.patchValue(element);
        this.listaDependentes.push(dependente);
      });
    })

    this.VisualizarMes()
  }
}
